import { atom } from 'recoil'
import { recoilPersist } from 'recoil-persist'
import { recoilKey } from './index'

const { persistAtom } = recoilPersist({ key: `${recoilKey}-FAV` })

export const favBookmarksViewMode = atom({
  key: 'favBookmarksViewMode',
  default: {
    viewLikeCard: false,
    showTags: true,
    showUrl: true,
    showDescription: false,
    showDate: false,
  },
  effects_UNSTABLE: [persistAtom],
})

export const favBookmarksSearchMode = atom({
  key: 'favBookmarksSearchMode',
  default: {
    title: true,
    description: true,
    url: true,
    tags: false,
    text: false,
  },
  effects_UNSTABLE: [persistAtom],
})

export const favBookmarksSortMode = atom({
  key: 'favBookmarksSortMode',
  default: '-createdAt',
  effects_UNSTABLE: [persistAtom],
})
